import classNames from 'classnames';
import React, { Children, isValidElement, cloneElement } from 'react';
import { __DEV__ } from "../../helper/dev.js";
import { useErrorProps } from "../../helper/hooks/useErrorProps.js";
import { Typography } from "../typography/Typography.js";
import styles from "./RadioGroup.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RadioGroup = ({
  name,
  title,
  onChange,
  error,
  value,
  className,
  wrap,
  horizontal,
  children,
  hasTiles,
  condensed = true,
  outline = false
}) => {
  const classes = classNames(styles.radioGroup, horizontal && styles.horizontal, horizontal && wrap && styles.wrap, hasTiles && styles.tiles, hasTiles && condensed && styles.condensed, className);
  const {
    errorMessage,
    errorInputProps
  } = useErrorProps({
    error
  });
  const childLength = Children.count(children);
  if (childLength === 0) {
    if (__DEV__) {
      // eslint-disable-next-line no-console
      console.error('[Invalid Children]: one or more <Radio /> elements expected - none received!');
    }
    return null;
  }
  if (__DEV__ && childLength <= 1) {
    // eslint-disable-next-line no-console
    console.error('[Invalid Children]: make sure you have more than one <Radio /> Element inside the <RadioGroup />');
  }

  // Normalize Radio Items and set global onChange and value/checked
  const normalizedChildren = Children.map(children, child => {
    if (/*#__PURE__*/isValidElement(child)) {
      const props = {
        name,
        onChange,
        error,
        isTile: hasTiles,
        // eslint-disable-next-line eqeqeq
        checked: child.props.value == value,
        condensed,
        outline
      };
      return /*#__PURE__*/cloneElement(child, props);
    }
    return null;
  })?.filter(Boolean);
  return /*#__PURE__*/_jsxs("div", {
    className: classes,
    children: [title && /*#__PURE__*/_jsx(Typography, {
      variant: "h5",
      className: styles.title,
      margin: !horizontal,
      children: title
    }), /*#__PURE__*/_jsx("div", {
      role: "radiogroup",
      className: styles.radioGroupContainer,
      ...errorInputProps,
      children: normalizedChildren
    }), errorMessage]
  });
};